export default {
    key: 'unlimited-pass-winter',
    common: {
        productName: 'core.productNames.unlimited-pass-winter',
        splashMessage: 'offerFlow.splashMessage.unlimited-pass-winter',
        headingAside: 'offerFlow.headingAside.unlimited-pass-winter',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.unlimited-pass-winter',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.unlimited-pass-winter',
        body: 'offerFlow.pages.stepPassengers.body.withReductions',
    },
} satisfies OfferFlowContent;
